<div class="card bg--primary">
    <h2 style="padding: 20px;">
        Page not found
    </h2>
    <div>
        <button (click)="goBack()">Go Back</button>
    </div>
</div>

